import React from "react";
import line from "../assets/line.png";
import First from "../assets/First.jpg";
import Lims1 from "../assets/Lims1.png";
import Lims2 from "../assets/Lims2.png";
import Lims3 from "../assets/Lims3.png";
import Lims44 from "../assets/Lims44.png"; 
import Lims5 from "../assets/Lims5.png";
import Lims6 from "../assets/Lims6.png";
import Lims7 from "../assets/Lims7.png";
import Lims8 from "../assets/Lims8.png";
import LimsInfographic from "../assets/LimsInfographic.svg";
import ColourLogo from "../assets/ColourLogo.svg";
import { Phone, Mail } from "lucide-react";
import { Link } from "react-router-dom";

const LimsPage = () => {
  return (
    <div className="min-h-screen scroll-smooth">
     
      {/* Hero Section with Video Background */}
      <section className="relative h-[50vh] sm:h-[60vh] flex items-center justify-center text-white overflow-hidden">
        <video
          className="absolute top-0 left-0 w-full h-full object-cover z-0"
          src="/Product780.mp4"
          autoPlay
          muted
          loop
          playsInline
        />
       <div className="absolute inset-0 bg-gradient-to-r from-[#0A1B60] via-[#1F2E8A] to-[#4B0FA3] opacity-40 z-10" />

        <div className="max-w-7xl mx-auto px-4 sm:px-6 w-full z-10 flex flex-col items-center text-center">
          <h1 className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl text-white font-bold">
            WISE LIMS
          </h1>
        <h2
  className="uppercase whitespace-nowrap font-extrabold text-transparent text-xl sm:text-3xl md:text-5xl lg:text-6xl xl:text-7xl mt-2"
  style={{
    fontFamily: "Calibri, sans-serif",
    WebkitTextStroke: "2px #ffffff",
    letterSpacing: "0.05em",
    lineHeight: "1.1",
  }}
>
  Precision-Driven Lab Management
</h2>

        </div>
      </section>

      {/* Vision Section */}
     <section className="py-10 sm:py-12 px-4 sm:px-6 bg-white flex flex-col items-center justify-center snap-start w-full !h-auto">
  <div className="max-w-6xl w-full mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 sm:gap-12 items-center">
    {/* Left - Text */}
    <div>
      <p className="text-gray-700 leading-relaxed text-sm sm:text-base md:text-lg text-justify">
        <span className="font-bold text-gray-900">WISE LIMS</span> is a modern,
        AI-integrated Laboratory Information Management System engineered to support
        complex biomedical, preclinical, and research lab workflows. Designed to
        manage everything from study setup to tissue analysis,{" "}
        <span className="font-bold text-gray-900">WISE LIMS</span> enables labs to
        meet the highest standards of quality, traceability, and regulatory
        compliance. Its robust architecture ensures seamless data collection,
        real-time analysis, and end-to-end workflow automation — transforming
        laboratory management across healthcare, life sciences, and research
        ecosystems.
      </p>
    </div>

    {/* Right - Image */}
    <div className="flex justify-center">
      <img
        src={Lims1}
        alt="WISE LIMS illustration"
        className="max-w-[332px] sm:max-w-[380px] md:max-w-[427px] lg:max-w-[475px] object-contain"
      />
    </div>
  </div>
</section>


   {/* Infographic */}
<section className="bg-white flex justify-center items-center py-2 sm:py-3">
  <img 
    src={LimsInfographic} 
    alt="Lims Infographic" 
    className="w-full max-w-[800px] h-auto px-4"
  />
</section>

{/* Study Management Module */}
<section className="pt-4 sm:pt-6 pb-10 sm:pb-12 px-4 sm:px-6 bg-white flex flex-col items-center justify-center w-full !h-auto">
  <div className="max-w-6xl w-full mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 sm:gap-12 items-center">
    <div className="flex justify-center order-1 md:order-1">
      <img
        src={Lims2}
        alt="Study Management Module"
        className="max-w-[220px] sm:max-w-sm md:max-w-md lg:max-w-lg object-contain"
      />
    </div>
    <div className="order-2 md:order-2">
      <p className="text-gray-700 leading-relaxed text-sm sm:text-base md:text-lg text-justify">
        <span className="font-bold" style={{ color: "#0077cc" }}>
          Study Management Module
        </span>{" "}
        Set up and manage the entire lifecycle of research studies including
        protocol approvals, resource planning, task scheduling, and subject
        tracking with built-in audit controls.
      </p>
    </div>
  </div>
</section>

{/* Drug Administration Module */}
<section className="py-4 sm:py-6 px-4 sm:px-6 bg-white flex flex-col items-center justify-center w-full !h-auto">
  <div className="max-w-6xl w-full mx-auto grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-10 items-center">
    <div className="order-2 md:order-1">
      <p className="text-gray-700 leading-relaxed text-sm sm:text-base md:text-lg text-justify">
        <span className="font-bold" style={{ color: '#0077cc' }}>
          Drug Administration Module
        </span>{' '}
        Digitally manage drug preparation, dosage tracking, administration
        logs, and safety events with validation workflows and audit trails to
        ensure protocol compliance.
      </p>
    </div>
    <div className="flex justify-center order-1 md:order-2">
      <img
        src={Lims3}
        alt="Drug Administration Module"
        className="max-w-[200px] sm:max-w-sm md:max-w-md lg:max-w-lg object-contain"
      />
    </div>
  </div>
</section>

{/* Process Evaluation Module */}
<section className="bg-gradient-to-r from-[#0A0E45] via-[#1E0F78] to-[#4B0EA6] text-white w-full py-6 sm:py-8 h-auto flex items-center justify-center">
  <div className="max-w-6xl w-full mx-auto grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-10 items-center px-4 sm:px-6">
    <div className="flex justify-center order-1 md:order-1">
      <img
        src={Lims44}
        alt="Process Evaluation Module"
        className="max-w-[200px] sm:max-w-sm md:max-w-md lg:max-w-lg object-contain"
      />
    </div>
    <div className="order-2 md:order-2">
      <p className="text-white leading-relaxed text-sm sm:text-base md:text-lg text-justify">
        <span className="font-bold" style={{ color: '#0077cc' }}>
          Process Evaluation Module
        </span>{' '}
        Log clinical observations, monitor real-time behavioral data, and
        analyze health status with dashboards for endpoint tracking and quality
        control metrics.
      </p>
    </div>
  </div>
</section>

{/* Tissue Processing */}
<section className="py-4 sm:py-6 px-4 sm:px-6 bg-white flex flex-col items-center justify-center w-full !h-auto">
  <div className="max-w-6xl w-full mx-auto grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-10 items-center">
    <div className="order-2 md:order-1">
      <p className="text-gray-700 leading-relaxed text-sm sm:text-base md:text-lg text-justify mb-0">
        <span className="font-bold" style={{ color: '#0077cc' }}>
          Tissue Processing &amp; Pathology Reporting
        </span>{' '}
        Facilitates necropsy and histology workflows with INHAND-compliant
        pathology data entry, peer reviews, and structured pathology report
        generation.
      </p>
    </div>
    <div className="flex justify-center order-1 md:order-2">
      <img
        src={Lims5}
        alt="Tissue Processing"
        className="max-w-[200px] sm:max-w-sm md:max-w-md lg:max-w-lg object-contain"
      />
    </div>
  </div>
</section>

{/* Reports Module */}
<section className="py-4 sm:py-6 px-4 sm:px-6 bg-white flex flex-col items-center justify-center w-full !h-auto">
  <div className="max-w-6xl w-full mx-auto grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-10 items-center">
    <div className="flex justify-center order-1 md:order-1">
      <img
        src={Lims6}
        alt="Reports Module"
        className="max-w-[200px] sm:max-w-sm md:max-w-md lg:max-w-lg object-contain"
      />
    </div>
    <div className="order-2 md:order-2">
      <p className="text-gray-700 leading-relaxed text-sm sm:text-base md:text-lg text-justify mb-0">
        <span className="font-bold" style={{ color: '#0077cc' }}>
          Reports Module
        </span>{' '}
        Generate and customize reports across study phases with templates,
        automation rules, and side-by-side comparisons for clear data
        interpretation and regulatory submissions.
      </p>
    </div>
  </div>
</section>

  {/* Audit & Compliance Module */}
<section className="py-4 sm:py-6 px-4 sm:px-6 bg-white flex flex-col items-center justify-center w-full !h-auto">
  <div className="max-w-6xl w-full mx-auto grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-10 items-center">
    <div className="order-2 md:order-1">
      <p className="text-gray-700 leading-relaxed text-sm sm:text-base md:text-lg text-justify mb-0">
        <span className="font-bold" style={{ color: '#0077cc' }}>
          Audit &amp; Compliance Module
        </span>{' '}
        Track every interaction with electronic signature support, complete
        audit trails, and validation against GLP, GCP, and other international
        regulatory standards.
      </p>
    </div>
    <div className="flex justify-center order-1 md:order-2">
      <img
        src={Lims8}
        alt="Audit & Compliance Module"
        className="max-w-[200px] sm:max-w-sm md:max-w-md lg:max-w-lg object-contain"
      />
    </div>
  </div>
</section>
 <section className="relative bg-gradient-to-r from-[#050A3A] via-[#1A0F6B] to-[#3E0E9F] overflow-hidden">
  {/* White curved part */}
  <div className="absolute top-[180px] left-0 w-full">
    <div className="bg-white rounded-t-[12rem] sm:rounded-t-[14rem] h-[120vh]"></div>
  </div>

  {/* Content */}
  <div className="relative z-10 px-6 sm:px-10 md:px-16 lg:px-24 pt-24 pb-16">
    {/* Top heading part */}
    <div className="text-center mt-[160px] mb-12">
       <h2
  className="text-4xl sm:text-5xl font-bold mb-2 text-[#6F7DFF]"
>
  Collaborate for Success
</h2>
      <p className="text-gray-700 text-lg sm:text-xl font-medium">
        Working together with others fosters innovation, creativity, and a greater sense of accomplishment.
      </p>
    </div>

    {/* Four-column footer part */}
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 text-gray-800">
      {/* About Us */}
      <div>
        <h3 className="font-bold mb-4 text-gray-900">ABOUT US</h3>
        <img src={ColourLogo} alt="Wissenstil Solutions" className="w-40 mb-4" />
      <p className="mb-4 leading-relaxed">
  Wissenstil Solutions is a specialized software company driving digital innovation.
</p>
      </div>

      {/* Services */}
      <div>
        <h3 className="font-bold mb-4 text-gray-900">SERVICES</h3>
        <ul className="space-y-2">
          <li>Image Analysis</li>
          <li>Anomaly Detection</li>
          <li>Medical Coding</li>
        </ul>
      </div>

  
{/* Useful Links */}
<div>
  <h3 className="font-bold mb-4 text-gray-900">USEFUL LINKS</h3>
  <ul
    className="space-y-2 text-gray-800"
    style={{ fontFamily: 'Calibri, sans-serif' }}
  >
    {[
      { name: "About Us", path: "/about" },
      { name: "Wise Services", path: "/services" },
      { name: "Wise Products", path: "/products" },
      { name: "Contact Us", path: "/contact" },
    ].map((link, index) => (
      <li
        key={index}
        className="transition-transform duration-300 hover:translate-x-2 text-base sm:text-lg md:text-xl"
      >
        <Link
          to={link.path}
          onClick={() => (window.location.href = link.path)}
          className="relative inline-block hover:text-purple-700 transition-colors duration-200 after:content-[''] after:absolute after:left-0 after:bottom-0 after:w-0 after:h-[2px] after:bg-purple-700 hover:after:w-full after:transition-all after:duration-300"
        >
          {link.name}
        </Link>
      </li>
    ))}
  </ul>
</div>

      {/* Contact */}
      <div>
        <h3 className="font-bold mb-4 text-gray-900">CONTACT US</h3>
        <p>
          Wissenstil Solutions Private Ltd.<br />
          Brigade IRV Centre, 09th &amp; 10th Floor,<br />
          Nallurahalli, Whitefield,<br />
          Bangalore, 560066.
        </p>
     

<div className="mt-4 space-y-3 text-white">
  <p className="flex items-center space-x-3">
    <Phone className="w-5 h-5 text-gray-900" />
    <span className="text-gray-900 font-medium">+91 9986158307</span>
  </p>
  <p className="flex items-center space-x-3">
    <Mail className="w-5 h-5 text-gray-900" />
    <span className="text-gray-900 font-medium">Manish.palliyil@wissenstil.com</span>
  </p>
</div>
      </div>
    </div>
  </div>
</section>



    </div>
  );
};

export default LimsPage;
